
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles.css'; // Import your styles if you have any

const root = ReactDOM.createRoot(document.getElementById('root'));
// Render the main App component
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
  // document.getElementById('root')
);